<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索登錄賬號|名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
						 	
					
					
					<el-row  :gutter="20" >
						<el-col :span="6" :xs="12">
							<el-tag >總金額：HK${{total_list.total}}</el-tag>
						</el-col>
						<el-col :span="6"  :xs="12">
							<el-tag type="success" >已支付：HK${{total_list.total_yes}}</el-tag>
						</el-col>
						
						<el-col :span="6" :xs="12" >
							<el-tag type="warning">待支付：HK${{total_list.total_mian}}</el-tag>
						</el-col>

						<el-col :span="6" :xs="12" >
							<el-tag type="danger"  >已取消：HK${{total_list.total_no}}</el-tag>
						</el-col>
						
					</el-row>
					<!-- <el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">添加學校</el-button> -->
					<!-- <el-button type="danger" v-auth="'delAdmin'" @click="deleteAll" size="mini">批量删除</el-button> -->
				</template>
				
				<!-- 高級搜索 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用戶名">
							<el-input size="small" v-model="from.name" placeholder="搜索用戶名"></el-input>
						</el-form-item>
						<el-form-item label="學校名稱">
							<el-input size="small" v-model="from.school_name" placeholder="搜索學校名稱"></el-input>
						</el-form-item>
						<el-form-item label="用戶ID">
							<el-input size="small" v-model="from.uid" placeholder="搜索用戶ID"></el-input>
						</el-form-item>
						<el-form-item label="訂單號">
							<el-input size="small" v-model="from.order_no" placeholder="搜索訂單號"></el-input>
						</el-form-item>
						<el-form-item label="發票編號">
							<el-input size="small" v-model="from.inv_no" placeholder="搜索發票編號"></el-input>
						</el-form-item>
						<el-form-item label="比賽編號">
							<el-input size="small" v-model="from.com_no" placeholder="搜索比賽編號"></el-input>
						</el-form-item>
						<el-form-item label="比賽名稱">
							<el-input size="small" v-model="from.com_title" placeholder="搜索比賽名稱"></el-input>
						</el-form-item>
						<el-form-item label="訂單類型">
							<el-select v-model="from.type" size="small" placeholder="請選擇訂單類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="報名" :value="1"></el-option>
								<el-option label="購買獎品" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="支付類型">
							<el-select v-model="from.pay_type" size="small" placeholder="請選擇支付類型">
                                <el-option label="全部" :value="-1"></el-option>
								<el-option label="無須付款" :value="0"></el-option>
								<el-option label="PayPal" :value="1"></el-option>
								<el-option label="支付寶" :value="2"></el-option>
								<el-option label="銀行轉賬" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="支付狀態">
							<el-select v-model="from.status" size="small" placeholder="請選擇支付狀態">
                                <el-option label="全部" :value="-1"></el-option>
								<el-option label="未支付" :value="0"></el-option>
								<el-option label="已支付" :value="1"></el-option>
								<el-option label="已取消" :value="2"></el-option>
								<el-option label="已收款處理中" :value="3"></el-option>
								<el-option label="已發貨" :value="4"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="創建時間"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="開始日期"
							      end-placeholder="結束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" >
				<el-table-column align="center" prop="no" label="用戶ID" ></el-table-column>
				<el-table-column align="center" prop="user_name" label="用戶" ></el-table-column>
				<el-table-column align="center" prop="order_no" label="訂單號"></el-table-column>
				<el-table-column align="center" prop="inv_no" label="發票編號" ></el-table-column>
				<el-table-column align="center" prop="school_name" label="學校" ></el-table-column>
				<el-table-column align="center" prop="com_no" label="比賽編號">
					</el-table-column>
						
					<el-table-column align="center" prop="title" label="比賽名稱">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 10">
										{{ scope.row.title.substring(0, 10) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
					</el-table-column>
				
					<el-table-column align="center" prop="type" label="訂單類型" width="120">
                    <template slot-scope="scope">
						<el-button v-if="scope.row.type === 2"  size="mini" plain type="success" @click="openDialog(scope.row.prize_info)"> {{ formatValue('type', scope.row.type).label }}</el-button>
                        <span 
							v-else
                            :style="{ 
                                color: formatValue('type', scope.row.type).color, 
                                cursor: scope.row.type === 2 ? 'pointer' : 'default' 
                            }"
                            @click="scope.row.type === 2 ? openDialog(scope.row.prize_info) : null"
                        >
						
                            {{ formatValue('type', scope.row.type).label }}
                        </span>
						
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="pay_type" label="支付類型" width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.pay_type === 3">
                            <el-popover trigger="hover" placement="top">
                                <p>銀行名稱: {{ scope.row.bank_name }}</p>
                                <p>銀行賬戶: {{ scope.row.bank_user_name }}</p>
                                <p>銀行卡號: {{ scope.row.bank_user_id }}</p>
                                <div slot="reference" class="name-wrapper">
                                    <span :style="{ color: formatValue('pay_type', scope.row.pay_type).color }">
                                        {{ formatValue('pay_type', scope.row.pay_type).label }}
                                    </span>
                                </div>
                            </el-popover>
                        </div>
                        <div v-else>
                            <span :style="{ color: formatValue('pay_type', scope.row.pay_type).color }">
                                {{ formatValue('pay_type', scope.row.pay_type).label }}
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="status" label="支付狀態" width="120">
                    <template slot-scope="scope">
                        <span :style="{ color: formatValue('status', scope.row.status).color }">
                            {{ formatValue('status', scope.row.status).label }}
                        </span>
                    </template>
                </el-table-column>

				<el-table-column align="center" prop="postage" label="郵費" ></el-table-column>
				<el-table-column align="center" prop="total_money" label="總金額" >
					<template slot-scope="scope">
						<span :class="scope.row.total_money> 0 ? 'money_text' : ''">{{ scope.row.total_money }}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center"  label="優惠金額">
						<template slot-scope="scope">
							<span v-if="scope.row.diamonds_money > 0 " class="money_text">鑽：{{ scope.row.diamonds_money }} <br></span>
							<span v-if="scope.row.dis_money > 0 " class="money_text">券：{{ scope.row.dis_money }} <br></span>
							<span v-if="scope.row.gold_money > 0 " class="money_text">幣：{{ scope.row.gold_money }}</span>
							<span v-if="scope.row.diamonds_money == 0 && scope.row.dis_money == 0 && scope.row.gold_money == 0">0</span>
						</template>
				</el-table-column>
				<el-table-column align="center" prop="money" label="應付" >
					<template slot-scope="scope">
						<span :class="scope.row.money> 0 ? 'money_text' : ''">{{ scope.row.money }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column align="center" prop="pay_time" label="支付時間" ></el-table-column> -->

				<el-table-column align="center" label="支付時間" >
					<template slot-scope="scope">
                        <span v-if="scope.row.status == 2" style="color: #dc3545;">
                            已取消
                        </span>
						<span v-else >
                            {{scope.row.pay_time}}
                        </span>
                    </template>

				</el-table-column>
				<el-table-column align="center" prop="create_time" label="創建時間" ></el-table-column>
		
				<el-table-column prop="id" align="center" width="250" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="orderInfo(scope.row.id)" v-if="scope.row.order_type == 1" v-auth="'edit'+auth_val"  size="mini" plain type="warning">詳細訂單</el-button>
							<el-button @click="reply(scope)" v-auth="'edit'+auth_val"  size="mini" plain type="success">發送郵件</el-button>
							<el-button
								v-if="scope.row.status == 0 || (scope.row.status == 3 && scope.row.type == 2) || (scope.row.status == 1 && scope.row.type == 2)"
								size="mini"
								plain
								:type="filteredStatusOptions(scope.row).color"
								v-auth="'edit' + auth_val"
								@click="openModel(scope,filteredStatusOptions(scope.row).type)"
								
							>
								
								{{ filteredStatusOptions(scope.row).label  }}
							</el-button>
							<el-button @click="handleCancelOrder(scope.row)" v-if="scope.row.status == 1 || scope.row.status == 3 || scope.row.status == 4" v-auth="'edit'+auth_val" size="mini" plain type="danger">取消</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

        <el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" width="50%" title="獎品詳情">
            <el-table :data="selectedRow" border style="width: 100%">
                <el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
                <el-table-column align="center" prop="content" label="簡介"></el-table-column>
                <el-table-column align="center" prop="money" label="金額"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">關閉</el-button>
            </span>
        </el-dialog>

		<el-dialog :close-on-click-modal="false"  title="編輯" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<div style="max-height: 65vh; overflow: auto;">
				<el-form   :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
					<el-form-item label="支付類型" prop="pay_type">
						<span :style="{ color: formatValue('pay_type', form.pay_type).color }">
							{{ formatValue('pay_type', form.pay_type).label }}
						</span>
					</el-form-item> 

					<el-form-item label="訂單號" prop="order_no">
						<span>{{form.order_no}}</span>
					</el-form-item>

					<el-form-item label="發票編號" prop="inv_no">
						<span>{{form.inv_no}}</span>
					</el-form-item>

					<el-form-item label="訂單類型" prop="type">
						<span :style="{ color: formatValue('type', form.type).color }">
							{{ formatValue('type', form.type).label }}
						</span>
					</el-form-item>

					<el-form-item label="總金額" prop="total_money">
						<span :class="form.total_money> 0 ? 'money_text' : ''">{{ form.total_money }}</span>
					</el-form-item>

					<el-form-item label="優惠金額">
						<span v-if="form.diamonds_money > 0 " class="money_text">鑽：{{ form.diamonds_money }} <br></span>
						<span v-if="form.dis_money > 0 " class="money_text">券：{{ form.dis_money }} <br></span>
						<span v-if="form.gold_money > 0 " class="money_text">幣：{{ form.gold_money }}</span>
						<span v-if="form.diamonds_money == 0 && form.dis_money == 0 && form.gold_money == 0">0</span>
					</el-form-item>

					<el-form-item label="應付" prop="money">
						<span :class="form.money> 0 ? 'money_text' : ''">{{ form.money }}</span>
					</el-form-item>
					
					<el-form-item label="獎品詳情" prop="prize_info" v-show="form.type == 2">
						<el-table :data="form.prize_info" border style="width: 100%">
							<el-table-column align="center" prop="name" label="獎品名稱"></el-table-column>
							<el-table-column align="center" prop="content" label="簡介"></el-table-column>
							<el-table-column align="center" prop="money" label="金額"></el-table-column>
						</el-table>
					</el-form-item>

					<!-- <el-form-item > -->
						<template > 
							<el-descriptions v-show="form.type == 1" class="margin-top" :column="2" style="margin-bottom: 30px;" border>
								
							<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									比賽編號
								</template>
								{{ form.com_no }}
								</el-descriptions-item>
								<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-mobile-phone"></i>
									機構名稱
								</template>
								{{ form.ins_name }}
								</el-descriptions-item>
								<el-descriptions-item>
								<template slot="label">
									<i class="el-icon-user"></i>
									比賽標題
								</template>
								{{ form.title }}
								</el-descriptions-item>
								
							</el-descriptions>

						</template>
					<!-- </el-form-item> -->

					<el-form-item label="訂單修改狀態" v-if="form.open_type == 3 && form.status == 0">
						<el-radio-group v-model="form.set_status" >
							<el-radio :label="1">已支付</el-radio>
							<el-radio :label="2">已取消</el-radio>
						</el-radio-group>
					</el-form-item>
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  title="訂單詳情" :visible.sync="orderInfoModel" top="5vh" :width="layout.is_phone?'90%':'90%'">
			<div style="max-height: 65vh; overflow: auto;">
				<el-table :data="tableOrderData" border style="width: 100%" >
					<el-table-column align="center" prop="user_no" label="用戶編號" ></el-table-column>
					<el-table-column align="center" prop="user_name" label="用戶" ></el-table-column>
					<el-table-column align="center" prop="order_no" label="訂單號"></el-table-column>
					<el-table-column align="center" prop="inv_no" label="發票編號" ></el-table-column>
					

					<el-table-column align="center" prop="school_name" label="學校" ></el-table-column>
					<el-table-column align="center" prop="type" label="訂單類型" width="120">
                    <template slot-scope="scope">
						<el-button v-if="scope.row.type === 2"  size="mini" plain type="success" @click="openDialog(scope.row.prize_info)"> {{ formatValue('type', scope.row.type).label }}</el-button>
                        <span 
							v-else
                            :style="{ 
                                color: formatValue('type', scope.row.type).color, 
                                cursor: scope.row.type === 2 ? 'pointer' : 'default' 
                            }"
                            @click="scope.row.type === 2 ? openDialog(scope.row.prize_info) : null"
                        >
						
                            {{ formatValue('type', scope.row.type).label }}
                        </span>
						
                    </template>
                </el-table-column>

					<el-table-column align="center" prop="pay_type" label="支付類型" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.pay_type === 3">
								<el-popover trigger="hover" placement="top">
									<p>銀行名稱: {{ scope.row.bank_name }}</p>
									<p>銀行賬戶: {{ scope.row.bank_user_name }}</p>
									<p>銀行卡號: {{ scope.row.bank_user_id }}</p>
									<div slot="reference" class="name-wrapper">
										<span :style="{ color: formatValue('pay_type', scope.row.pay_type).color }">
											{{ formatValue('pay_type', scope.row.pay_type).label }}
										</span>
									</div>
								</el-popover>
							</div>
							<div v-else>
								<span :style="{ color: formatValue('pay_type', scope.row.pay_type).color }">
									{{ formatValue('pay_type', scope.row.pay_type).label }}
								</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="status" label="支付狀態" width="120">
						<template slot-scope="scope">
							<span :style="{ color: formatValue('status', scope.row.status).color }">
								{{ formatValue('status', scope.row.status).label }}
							</span>
						</template>
					</el-table-column>

					<el-table-column align="center" prop="postage" label="郵費" ></el-table-column>
					<el-table-column align="center" prop="total_money" label="總金額" >
						<template slot-scope="scope">
							<span :class="scope.row.total_money> 0 ? 'money_text' : ''">{{ scope.row.total_money }}</span>
						</template>
					</el-table-column>
					
					<el-table-column align="center"  label="優惠金額">
							<template slot-scope="scope">
								<span v-if="scope.row.diamonds_money > 0 " class="money_text">鑽：{{ scope.row.diamonds_money }} <br></span>
								<span v-if="scope.row.dis_money > 0 " class="money_text">券：{{ scope.row.dis_money }} <br></span>
								<span v-if="scope.row.gold_money > 0 " class="money_text">幣：{{ scope.row.gold_money }}</span>
								<span v-if="scope.row.diamonds_money == 0 && scope.row.dis_money == 0 && scope.row.gold_money == 0">0</span>
							</template>
					</el-table-column>
					<el-table-column align="center" prop="money" label="應付" >
						<template slot-scope="scope">
							<span :class="scope.row.money> 0 ? 'money_text' : ''">{{ scope.row.money }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="pay_time" label="支付時間" ></el-table-column>
					<el-table-column align="center" prop="create_time" label="創建時間" ></el-table-column>
			
					<el-table-column prop="id" align="center" width="140" label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button @click="reply(scope)" v-auth="'edit'+auth_val"  size="mini" plain type="success">發送郵件</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button @click="orderInfoModel = false">關閉</el-button>
            </span>
		</el-dialog>

		<el-dialog  :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="內容">
			<p>{{ fullTitle }}</p>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"  
			title="回覆消息" 
			:visible.sync="createReplyModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '50%'" 
			class="custom-dialog"
			>
			<div style="max-height: 65vh; overflow: auto;">
				<el-form :rules="rulesReply" ref="formEdit" :model="Replyform" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
					<template> 
						<el-descriptions v-if="Replyform.order_type == 0 || Replyform.order_type == 2" class="margin-top" title="學生信息" :column="3" style="margin-bottom: 30px;" border>
							
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								姓名
							</template>
							{{ Replyform.user_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								英文名
							</template>
							{{ Replyform.name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								電話
							</template>
							{{ Replyform.phone }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								郵箱
							</template>
							{{ Replyform.email }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-school"></i>
								名稱
							</template>
							{{Replyform.school_name}}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-collection"></i>
								年級
							</template>
							{{Replyform.g_name}}
							</el-descriptions-item>
						</el-descriptions>

						<el-descriptions v-if="Replyform.order_type == 1" class="margin-top" title="學校信息" :column="3" style="margin-bottom: 30px;" border>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								名稱
							</template>
							{{ Replyform.school_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								英文
							</template>
							{{ Replyform.name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								校長
							</template>
							{{ Replyform.rector }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								電話
							</template>
							{{ Replyform.phone }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								地址
							</template>
							{{ Replyform.local }}
							</el-descriptions-item>
						</el-descriptions>

					</template>
					<!-- 顶部信息展示区 -->
				

					<!-- 回复標題輸入 -->
					<el-form-item label="回覆標題" prop="reply_title">
					<el-input 
						type="text" 
						v-model="Replyform.reply_title"
						maxlength="50"
						show-word-limit
						placeholder="回覆標題"
						clearable 
						size="small" 
						class="form-input"
					/>
					</el-form-item>

					<!-- 回复内容輸入 -->
					<el-form-item label="回覆内容" prop="reply_content">
					<el-input 
						type="textarea" 
						:rows="3" 
						v-model="Replyform.reply_content"
						show-word-limit
						placeholder="回覆内容"
						clearable 
						size="small" 
						class="form-input"
					/>
					</el-form-item>

				</el-form>
		
				<!-- 底部按钮 -->
				<div slot="footer" class="dialog-footer">
					<el-button @click="createReplyModel = false">取消</el-button>
					<el-button type="primary" @click="submitRrply">確定</el-button>
				</div>
			</div>
			</el-dialog>


	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				orderInfoModel:false,
				tableOrderData:[],
				rulesReply: {
					reply_content: [{
							required: true,
							message: "回覆內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "回覆標題不能為空",
							trigger: 'blur',
						},
					],
				
					
				},

				dialogTitleVisible: false,
				fullTitle: '',

				Replyform:{},
				total_list: {}, 
                dialogVisible: false,
                createReplyModel: false,
                selectedRow: {},
                tableData: [],
				form: {}, 
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					order_no: '',
					com_no: '',
					com_title: '',
					name: '',
					school_name: '',
					uid: '',
					inv_no: '',
					type: -1,
					pay_type: -1,
					status: -1,
				},
				auth_val: 'UserOrder',
				preUrl: "user/UserOrder", //列表地址
				addUrl: "user/editOrder", //添加/修改地址
				delUrl: "user/delShop", //删除單条地址
				delAllUrl: "user/delShopAll", //批量删除地址
				editStatusUrl:"user/editStatusSchoolAdmin",//修改狀態地址
				
				
			
				rule_list: [],
				address_list:[],
				check_img_list:[]
			}
		},
		
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['address_list']);
		},
		methods: {
			handleCancelOrder(row) {
				this.$confirm(
				`當前操作是取消訂單（訂單號：${row.order_no}），此操作不可撤銷，請確認是否繼續？`, 
				'警告', 
				{
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning',
				}
				).then(() => {
					// 執行取消訂單的邏輯
					this.cancelOrder(row);
				}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消操作已被終止',
				});
				});
			},
					 // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			cancelOrder(row) {
				this.axios.post('/admin/data/handleCancelOrder', 
							{orderId: row.id},
						 {
							token: true,
						}).then(all => {
							this.$message({
								type: 'success',
								message: '訂單已成功取消！',
							});
							// 可能需要更新列表數據
							this.getList();
						}).catch(err => {
							// 失敗
							this.$message.error('取消訂單失敗，請稍後重試');
						})
			},
			reply(e){
				// 初始化表單數據
				this.Replyform = {
					id: e.row.id,
					user_name: e.row.user_name,
					order_type: e.row.order_type,
					uid: e.row.uid,
					name_en: e.row.name_en,
					school_name: e.row.school_name,
					g_name: e.row.g_name,
					year: e.row.year,
					mot: e.row.mot,
					email: e.row.email,
					phone: e.row.phone,
					rector: e.row.rector,
					local: e.row.local,
					in_type: e.row.order_type == 1 ? 3 : 4,
					in_id: e.row.order_type == 1 ? e.row.is_school : e.row.uid,
					reply_content: '',
					reply_title: '',
					reply_type:1,
				};
				
				this.editIndex = e.row.id;
				this.createReplyModel = true;
			},
            openDialog(row) {
                this.selectedRow = row;
                this.dialogVisible = true;
            },
			submitRrply() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.layout.loading = true;
						this.axios.post('/admin/data/replyUserEmail', 
							this.Replyform,
						 {
							token: true,
						}).then(all => {
							console.log(all)
							if (all.data.code == 1) {
									this.$message({
										message: all.data.msg,
										type: 'success'
									}); // 控制是否顯示成功提示
								
								this.createReplyModel = false;
								this.layout.loading = false;
							}
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
						})
					}
				})
				
			},
			orderInfo(order_id){
				this.axios.post('/admin/data/orderInfoList', 
							{order_id:order_id},
						 {
							token: true,
						}).then(all => {
							if (all.data.code == 1) {
								this.tableOrderData = all.data.data.list.list;
								this.orderInfoModel = true;
								this.layout.loading = false;
							}
						}).catch(err => {
							// 失敗
							this.layout.loading = false;
						})
			},
            formatValue(type, value) {
                const mappings = {
                    type: { 
                        labels: { 1: '報名', 2: '購買獎品' }, 
                        colors: { 1: '#409EFF', 2: '#67C23A' } // Blue, Green
                    },
                    pay_type: { 
                        labels: { 0: '無須付款', 1: 'PayPal', 2: '支付寶', 3: '銀行轉賬' },
                        colors: { 0: '#909399', 1: '#409EFF', 2: '#F56C6C', 3: '#E6A23C' } // Gray, Blue, Red, Orange
                    },
                    status: { 
                        labels: { 0: '未支付', 1: '已支付', 2: '已取消', 3: '已收款處理中', 4: '已發貨' },
                        colors: { 0: '#F56C6C', 1: '#67C23A', 2: '#dc3545', 3: '#E6A23C', 4: '#409EFF' } // Red, Green, Gray, Orange, Blue
                    }
                };

                const label = mappings[type]?.labels[value] || '未知';
                const color = mappings[type]?.colors[value] || '#909399';

                return { label, color };
            },
            filteredStatusOptions(data) {
				if (data.status === 3) {
					// 當狀態為 "已收款處理中" 時，只允許修改為 "已發貨"
					return { label:'發貨', color:'success', type:1 };
				} 
				// else if (data.status === 0 && data.pay_type === 3) {
				// 	// 當狀態為 "未支付" 且支付類型為 "銀行轉賬" 時，允許 "已支付" 和 "已取消"
				// 	return '編輯';
				// }
				 else if (data.status === 1 && data.type === 2) {
					// 當訂單類型為 2 時，允許所有選項
					return { label:'已處理', color:'warning', type:2 };
				}
				 else {
					// 預設選項：顯示 "未支付"、"已支付" 和 "已取消"
					return { label:'操作', color:'primary', type:3 };
				}
			},

			// 打开模态框
			openModel(e = false, type = 3) {
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					status: e.row.status,
					inv_no: e.row.inv_no,
					order_no: e.row.order_no,
					type: e.row.type,
					pay_type: e.row.pay_type,
					open_type: type,
					bank_name: e.row.bank_name,
					bank_user_name: e.row.bank_user_name,
					bank_user_id: e.row.bank_user_id,
					prize_info: e.row.prize_info,
					com_no: e.row.com_no,
					title: e.row.title,
					ins_name: e.row.ins_name,
					money: e.row.money,
					total_money: e.row.total_money,
					dis_money: e.row.dis_money,
					diamonds_money: e.row.diamonds_money,
					gold_money: e.row.gold_money,
				};
				this.editIndex = e.row.id;

				// 根據 open_type 顯示確認提示
				if (type === 2) {
					this.$confirm('訂單是否已處理？', '提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning',
					}).then(() => {
						// 設置狀態為 3 並提交
						this.form.set_status = 3;
						this.addOrEdit(this.form);
					}).catch(() => {
						// 如果選擇取消，不做操作
						console.log("操作已取消");
					});
				} else if (type === 1) {
					this.$confirm('訂單是否已發貨？', '提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning',
					}).then(() => {
						// 設置狀態為 4 並提交
						this.form.set_status = 4;
						this.addOrEdit(this.form);
					}).catch(() => {
						// 如果選擇取消，不做操作
						console.log("操作已取消");
					});
				} else {
					// 正常打開表單編輯模式
					this.createModel = true;
				}
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
					}
				})
			},

			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.address_list = all.data.list.address

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					order_no: '',
					com_no: '',
					com_title: '',
					name: '',
					school_name: '',
					uid: '',
					inv_no: '',
					type: -1,
					pay_type: -1,
					status: -1,
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
